import AppContent, { IAssetBase } from "@/apps/app.content";

export class ContentLoadHandler {

  private static loader: AppContent;

  // eslint-disable-next-line @typescript-eslint/ban-types
  private static promiseCallbacks: Map<string, Function> = new Map();
  private static loadedAssets: Map<string, IAssetBase> = new Map();

  public static init(loader: AppContent): void {
    this.loader = loader;
  }

  // Can load asset and wait for it to load
  public static async loadAsset<T extends IAssetBase>(asset: T): Promise<T> {
    if (asset.id === undefined) {
      throw new Error('Asset id is undefined.');
    }

    if (this.loadedAssets.has(asset.id)) {
      return Promise.resolve(this.loadedAssets.get(asset.id) as T);
    }

    const promise = new Promise<T>((resolve) => {
      const callback = (asset: T) => {
        if (asset.id === asset.id) {
          resolve(asset as T);
          this.promiseCallbacks.delete(asset.id!);
        }
      }
      this.promiseCallbacks.set(asset.id!, callback);
      this.loader.loadContents([asset]);
    });

    return promise;
  }

  // Can get existing asset or wait for it to load
  public static getAsset<T extends IAssetBase>(id: string): T | undefined {

    const asset = this.loadedAssets.get(id);
    if (asset) {
      return asset as T;
    }

    return undefined;
  }

  // Check if asset is loaded
  public static isAssetLoaded(id: string): boolean {
    return this.loadedAssets.has(id);
  }

  public static loadAssetComplete(asset: IAssetBase): void {
    if (asset.id === undefined) {
      return;
    }

    this.loadedAssets.set(asset.id, asset);

    const callback = this.promiseCallbacks.get(asset.id);
    if (callback) {
      callback(asset);
    }
  }


}
